<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title>Pay {{ user.fullName }}</v-card-title>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="payout.methodId"
                :items="contributor_payout_methods"
                item-text="name"
                item-value="id"
                label="Method"
                hide-details="auto"
                outlined
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <OutlinedInput
                label="Sub Total"
                :legend-width="62"
              >
                <div class="my-auto">
                  {{ payout.subTotal | currency }}
                </div>
              </OutlinedInput>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="payout.bonus"
                label="Bonus"
                outlined
                hide-details="auto"
                @input="updateTotal"
              />
            </v-col>
            <v-col cols="12">
              <OutlinedInput
                label="Total"
                :legend-width="35"
              >
                <div class="my-auto">
                  {{ payout.total | currency }}
                </div>
              </OutlinedInput>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="payout.notes"
                label="Notes"
                hide-details="auto"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="pay"
        >
          Pay
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import OutlinedInput from '@/components/common/OutlinedInput';
export default {
  name: 'UserPayDrawer',
  components: { OutlinedInput },
  data() {
    return {
      valid: false,
      drawer: false,
      saving: false,
      payout: {}
    };
  },
  computed: {
    user() {
      return this.users.find((x) => x.id === this.payout.userInfoId) || this.single_user;
    },
    ...mapGetters({
      contributor_payout_methods: 'lookup/contributor_payout_methods',
      user: 'users/list',
      single_user: 'users/user'
    })
  },
  mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.PAY_DRAWER_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.PAY_DRAWER_SHOW, (data) => {
      this.payout = {
        subTotal: data.subTotal,
        userInfoId: data.userId,
        bonus: 0
      };
      this.updateTotal();
      this.drawer = true;
    });
  },
  methods: {
    updateTotal() {
      this.payout.total = parseFloat(this.payout.subTotal) + parseFloat(this.payout.bonus);
    },

    pay() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      this.$store
        .dispatch('users/addPayout', this.payout)
        .then(() => {
          this.drawer = false;
          this.$root.$snackbarSuccess('Payout added');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
